<template>
  <div>
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step :complete="step > 1" step="1" color="success">Výběr jídelníčku</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 2" step="2" color="success">Výběr jídla</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 3" step="3" color="success">Košík</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 4" step="4" color="success">Rekapitulace</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 5" step="5" color="success">Dokončení objednávky</v-stepper-step>
      </v-stepper-header>
      <v-alert type="error" v-if="creditError">Nedostatek kreditu</v-alert>
      <v-stepper-items>
        <v-stepper-content step="1">
          <Step1 @order-canceled="$emit('order-canceled')"></Step1>
        </v-stepper-content>

        <v-stepper-content step="2">
          <Step2 @order-canceled="$emit('order-canceled')"></Step2>
        </v-stepper-content>

        <v-stepper-content step="3">
          <Step3 @order-canceled="$emit('order-canceled')"></Step3>
        </v-stepper-content>
        <v-stepper-content step="4">
          <Step4 @order-canceled="$emit('order-canceled')"></Step4>
        </v-stepper-content>
        <v-stepper-content step="5">
          <v-card
            class="mb-12 d-flex justify-center"
            color="white"
            flat
            height="200px"
          >
            <div id="order-finished" class="d-flex justify-center align-center align-self-center ">
              <v-icon x-large color="success">mdi-check</v-icon>
              <h3>Objednávka dokončena</h3>
            </div>
          </v-card>
          <v-btn color="success" class="order-control-buttons" @click="finishOrder">Hotovo</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Step1 from '@/components/forms/order/Step1'
import Step2 from '@/components/forms/user/Step2'
import Step3 from '@/components/forms/user/Step3'
import Step4 from '@/components/forms/user/Step4'
export default {
  components: { Step4, Step3, Step2, Step1 },
  props: ['order'],
  name: 'OrderForm',
  data () {
    return {
      creditError: false,
      addToCartDialog: false,
      shoppingCart: { ...this.order.shoppingCart }
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      step: 'ordering/step'
      /* totalItemsPrice: 'ordering/totalItemsPrice',
      totalDeliveryPrice: 'ordering/totalDeliveryPrice',
      totalPackagingPrice: 'ordering/totalPackagingPrice',
      totalOrderPrice: 'ordering/totalOrderPrice', */
    }),
    cart: {
      get () {
        return this.$store.state.ordering.cart
      },
      set (cart) {
        this.$store.commit('ordering/setCart', cart)
      }
    }
  },
  methods: {
    initialize () {
      if (this.order.id) {
        this.cart = this.order.shoppingCart

        this.$http.get(`/users/${this.order.shoppingCart.user.id}`)
          .then(response => {
            this.cart.user.credit = response.data.credit
          })
      } else {
        this.reset()
      }
      this.$store.commit('ordering/setOrderObject', this.order)

      this.$http.get('/admin/times')
        .then(response => {
          const timeTypes = this.keysToCamelCase(response.data)
            .filter(time => time.active)
          this.setTimeTypes(timeTypes)
        })
        .catch(err => {
          console.log(err)
        })

      if (this.order.id) {
        this.$http.get(`/admin/user/${this.shoppingCart.user.id}/boarders`)
          .then(response => {
            this.availableBoarders = this.keysToCamelCase(response.data)
              .map(boarder => {
                boarder.fullName = `${boarder.firstName} ${boarder.lastName}`
                return boarder
              })

            this.shoppingCart.boarders = this.order.shoppingCart.boarders
          })
          .catch(err => { console.log(err) })
      }
    },
    cancelOrder () {
      this.$emit('order-canceled')
    },
    finishOrder () {
      this.reset()
      this.$emit('order-finished')
    },
    ...mapMutations({
      updateShoppingCartStorage: 'ordering/updateShoppingCartStorage',
      setTimeTypes: 'ordering/updateTimeTypes',
      reset: 'ordering/reset'
    })
  },
  created () {
    this.initialize()
  },
  beforeDestroy () {
    this.reset()
  },
  watch: {
    'shoppingCart.diet': function (val) {
      this.shoppingCart.boarders = []
      // if user was selected and can order from diet, it stays in the cart
      this.shoppingCart.order = this.shoppingCart.user.institutionId === val.institutionId && this.shoppingCart.order
    },
    'shoppingCart.user': function () {
      this.$http.get(`/admin/user/${this.shoppingCart.user.id}/boarders`)
        .then(response => {
          this.availableBoarders = this.keysToCamelCase(response.data)
            .map(boarder => {
              boarder.fullName = `${boarder.firstName} ${boarder.lastName}`
              return boarder
            })
        })
        .catch(err => { console.log(err) })
    },
    step (val) {
      this.updateShoppingCartStorage()
      if (val === 5 && this.currentUser.roleId === 6) {
        this.getCredit()
      }
    }
  }
}
</script>

<style scoped>
.order-quantity{
  max-width: 150px;
  margin-right: 0 !important;
  margin: auto;
}
  .order-table{
    margin-bottom: 25px;
  }
  .cart-heading{
    min-width: 100px;
  }
  .order-control-buttons{
    float: right;
  }
  .order-card-mr-0{
    margin-right: 0 !important;
  }
  .order-card-ml-0{
    margin-left: 0 !important;
  }
.inputPrice input[type='number'] {
  -moz-appearance:textfield;
}
.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.v-expansion-panel{
  margin-top: 5px !important
}
  .cart-4-step{
    width: 85%;
    margin: auto;
  }
</style>
